import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { MatDialog } from '@angular/material';
import { Router } from '@angular/router';
import { Auth } from '../../../autentication/Auth';
import { SharedModalInfoComponent } from '../../../shared/modal-info/modal-info.component';
import { Util } from '../../../utils/util';
import { PixHelpComponent } from '../help/help.component';
import { FaixaHorario, PixLimitsReturn, PixLimitsReturnTipo } from '../models/limits-return.model';
import { PixLimitsService } from './limits.service';
import { PixModalReducedLimitComponent } from './modal-reduced-limit/modal-reduced-limit.component';

@Component({
	selector: 'app-limits',
	templateUrl: './limits.component.html',
	styleUrls: ['./limits.component.styl'],
	encapsulation: ViewEncapsulation.None
})
export class PixLimitsComponent implements OnInit {

	public daylyLimitValue = 0;
	public daylyFaixaHorario: FaixaHorario;
	public nightlyLimitValue = 0;
	public nightlyFaixaHorario: FaixaHorario;
	public isTransactionUser = false;
	public limits: PixLimitsReturn[] = [];

	constructor(
		private router: Router,
		public dialog: MatDialog,
		public pixLimitsService: PixLimitsService
	) { }

	ngOnInit() {
		this.getLimits();
		this.setIsTransactionUser();
	}

	getLimits() {
		this.pixLimitsService.getLimits().subscribe(result => {
			if (result && result.Existe && result.Sucesso) {
				const items = Util.keysToCamel(result.Retorno) as PixLimitsReturn[];
				this.limits = items;

				items.forEach(o => {
					switch (o.tipo) {
						case PixLimitsReturnTipo.PIX_DIURNO: {
							this.daylyLimitValue = o.valor;
							this.daylyFaixaHorario = o.faixaHorario;
							break;
						}
						case PixLimitsReturnTipo.PIX_NOTURNO: {
							this.nightlyLimitValue = o.valor;
							this.nightlyFaixaHorario = o.faixaHorario;
							break;
						}
					}
				});
			}
		});
	}

	public adjustLimit(tipo: PixLimitsReturnTipo) {
		const selectedLimit = this.limits.find(limit => limit.tipo === tipo);

		selectedLimit.valorMaximo = selectedLimit.valor;

		this.pixLimitsService.setSelectedLimit(selectedLimit);

		this.router.navigate(['pix/limites/ajustar']);
	}

	public openModalAlert(tipo: PixLimitsReturnTipo) {
		let title = '';
		let text = '';

		switch (tipo) {
			case PixLimitsReturnTipo.PIX_FAVORECIDOS: {
				title = 'Favorecidos cadastrados';
				text = 'São pessoas ou empresas que você já fez um pagamento ou transferência anteriomente e tem salvo em sua lista de favorecidos.';
				break;
			}
			case PixLimitsReturnTipo.PIX_NAO_FAVORECIDOS: {
				title = 'Favorecidos não cadastrados';
				text = 'São pessoas ou empresas que você está fazendo um pagamento ou transferência pela primeira vez, ou que já realizou transações anteriormente, mas não salvou em sua lista de favorecidos.';
				break;
			}
			case PixLimitsReturnTipo.PIX_QRCODE: {
				title = 'Pix com QRCode';
				text = 'Pagamentos e transferências para pessoas ou empresas utilizando a leitura do QR Code.';
				break;
			}
		}

		this.dialog.open(SharedModalInfoComponent, {
			width: '360px',
			data: {
				title: title,
				text: text,
				btnName: 'Entendi',
			}
		});
	}

	public openModalAlertNoturno() {
		const selectedLimit = this.limits.slice().find(limit => limit.tipo === PixLimitsReturnTipo.PIX_FORA_HORARIO);

		this.dialog.open(PixModalReducedLimitComponent, {
			width: '360px',
			data: {
				selectedLimit: selectedLimit
			}
		});
	}

	public openHelpModal() : void {
		this.dialog.open(PixHelpComponent, {
			width: '400px',
		});
	}

	public goBack = () => this.router.navigate(['pix/']);

	public get pixLimitsReturnTipo(): typeof PixLimitsReturnTipo {
		return PixLimitsReturnTipo;
	}

	private setIsTransactionUser() {
		this.isTransactionUser = Auth.getInstance().getUser().rule === 'TRANSACIONAR';
	}
}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/dev-omni-internetbanking-deploy/src/app/master/pix/limits/limits.component.ts